import { getPharmacies, handleAxiosError } from '@/services/axiosService';

const state = {
    portals: {}
};

const actions = {
    async getPharmacies({ commit }) {
        try {
            const pharmacies = await getPharmacies(true);
            commit('pharmacies_request', pharmacies);
        } catch (error) {
            handleAxiosError(error);
            if (error.response && error.response.status === 401) {
                commit('pharmacies_error', error.response.data.message);
            }
        }
    }
};

const getters = {
    pharmacies: state => state.portals
};

const mutations = {
    pharmacies_request(state, pharmacies) {
        state.pharmacies = pharmacies;
    },
    pharmacies_error(state, message) {
        state.pharmacies = {
            error: true,
            message: message
        };
    }
};

export default {
    actions,
    getters,
    mutations,
    namespaced: true,
    state
};
